import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const StarIcon = (props: IconProps) => (
  <ChakraIcon viewBox="13.00 13.00 37.00 37.00" {...props}>
    <polygon fill="currentColor" points="31.5 14 36.9081481 25.5218238 49 27.3684342 40.25 36.3365163 42.3157778 49 31.5 43.0218238 20.6842222 49 22.75 36.3365163 14 27.3684342 26.0918519 25.5218238" fillRule="evenodd" />
  </ChakraIcon>
)

export default StarIcon
